<script setup lang="ts">
import { defineProps, computed } from "vue";
import newShade from "../../helper/cssHelper";

const props = defineProps({
  tagTitle: {
    type: String,
    required: true,
  },

  bgColor: {
    type: String,
    required: false,
    default: "#2B48A2",
  },

  width: {
    type: String,
    required: false,
    default: "fit-content",
  },

  color: {
    type: String,
    required: false,
    default: "#ffffff",
  },

  type: {
    type: String,
    values: ["success", "info", "warning", "danger", ""],
    default: "",
  },

  round: {
    type: Boolean,
    default: false,
  },

  outline: {
    type: Boolean,
    default: false,
  },

  transparent: {
    type: Boolean,
    default: false,
  },
});

const TagClass = computed(() => {
  const { type, round, outline, transparent } = props;
  return [
    "tag",
    round ? "round" : "",
    outline ? "outline" : "",
    transparent ? "transparent" : "",
    "tag" + "-" + type,
  ];
});
</script>

<template>
  <span :class="TagClass">
    <span class="tag__content">
      {{ props.tagTitle }}
    </span>
  </span>
</template>

<style lang="scss" scoped>
.tag {
  background-color: v-bind("props.bgColor");
  color: white;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 24px;
  padding: 0 9px;
  font-size: 12px;
  line-height: 1;
  border-width: 1px;
  border-style: solid;
  box-sizing: border-box;
  white-space: nowrap;
  size: 14px;

  &.transparent {
    opacity: 0.8;
  }

  &.round {
    border-radius: 12px;
  }

  &-info {
    background-color: #2B48A2;
    color: white;
  }

  &.outline {
    background-color: transparent;
    border-color: v-bind("props.bgColor");
    color: v-bind("props.bgColor");
  }

  &.outline:hover {
    background-color: v-bind("props.bgColor");
    border-color: v-bind("props.bgColor");
    color: white;
    cursor: pointer;
  }
}
</style>
